import React from 'react';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import Stats from '../components/sections/Stats';
import Services from '../components/sections/Services';
import Products from '../components/sections/Products';
import BusinessModels from '../components/sections/BusinessModels';
import Standards from '../components/sections/Standards';
import WhyTrustUs from '../components/sections/WhyTrustUs';
import FAQ from '../components/sections/FAQ';
import CTA from '../components/sections/CTA';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Products />
        <BusinessModels />
        <Standards />
        <WhyTrustUs />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
